<template>
<div class="chapter">
<div class="inner_page">
<h1 class="subtitle">AFRO-ASIAN-AMERICAN COOKING FOR<br/>BIG NIGHTS, WEEKNIGHTS, &amp; EVERY DAY</h1>
<h1 class="title">Between<br/>Harlem<br/><span class="small">AND</span><br/>Heaven</h1>
<h2 class="author">JJ JOHNSON AND<br/>ALEXANDER SMALLS</h2>
<p class="center_t"><em>with Veronica Chambers</em></p>
<p class="centert">PHOTOGRAPHY BY</p>
<p class="centert1">Beatriz da Costa</p>
<p class="centert">FOOD STYLING BY</p>
<p class="centert1">Roscoe Betsill</p>
<p class="graphic"><img alt="images" src="OEBPS/images/3-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?11cd8e90